export const CORE_DEFAULT_VALUES = {
  defaultCountryState: null,
  currencyState: '£',
  isInternationalCountryName: false,
};
